import { useState } from 'react';

import GTNGameComponent from './GTN_Game';

import './GTN.css';

const GTNComponent = () => {
    const [players, setPlayers] = useState(1);
    const [playerNames, setPlayerNames] = useState([]);
    const [GTNState, setGTNState] = useState(0);
    
    const savePlayerAmount = () => {
        setGTNState(1);
        return true;
    };
    
    const savePlayerNames = () => {
        for (let i = 0; i < players; i++) {
            if (!playerNames[i]) return false;
        };
        
        setGTNState(GTNState + 1);
        return true;
    };
    
    const setPlayerName = (playerNumber, newName) => {
        const playerNameCopy = [...playerNames];
        playerNameCopy[playerNumber] = newName;
        setPlayerNames(playerNameCopy);
        return true;
    };
    
    const handleSetPlayers = (number) => {
        if (number > 4 || (number < 1 && number !== '')) return;
        setPlayers(number);
    }
    
    const addPlayerNameInput = (playerNumber) => {
        return (
            <div className='gtn-playername-input-div'>
                <p style={{fontWeight: '600'}}>Player {playerNumber + 1}</p>
                <input  className='gtn-playername-input'
                    type='text' 
                    minLength={1} 
                    maxLength={20}
                    value={playerNames[playerNumber] ? playerNames[playerNumber] : ''}
                    onChange={(e) => setPlayerName(playerNumber, e.target.value)}
                    onKeyDown={(e) => handleKeyDown(e, savePlayerNames)}
                    autoFocus={playerNumber === 0}
                />
            </div>
        );
    };
    
    const handleKeyDown = (e, callback) => {
        if (e.keyCode === 9 || e.keyCode === 13) {
            if (callback())  e.preventDefault();
        };
        
        if (e.keyCode === 27) {
            e.preventDefault();
            setGTNState(GTNState - 1);
        };
    };
    
    
    return (
        <div id='GTN-container'>
            <h2>Guess The Number</h2>
            
            {GTNState === 0 ?
                <>
                    <p className='gtn-describe-p'>How many players? (1-4)</p>
                    <div id='gtn-playeramount-container'>
                        <input id='gtn-playeramount-input'
                            type='number' 
                            value={players} 
                            min={1} 
                            max={4}
                            onChange={(e) => handleSetPlayers(e.target.value)}
                            onKeyDown={(e) => handleKeyDown(e, savePlayerAmount)}
                        />
                        <button type='button' id='gtn-playeramount-button'
                            onClick={savePlayerAmount}
                        >Submit</button>
                    </div>
                </>
            :GTNState === 1 ?
                <>
                    <p className='gtn-describe-p'>Enter player names</p>
                    {players >= 1 && addPlayerNameInput(0)}
                    {players >= 2 && addPlayerNameInput(1)}
                    {players >= 3 && addPlayerNameInput(2)}
                    {players >= 4 && addPlayerNameInput(3)}
                    
                    <div id='gtn-playername-button-div'>
                        <button type='button' id='gtn-playername-button'
                            onClick={savePlayerNames}
                        >Submit</button>
                    </div>
                </>
                
            :GTNState === 2 &&
                <>
                    <GTNGameComponent players={players} playerNames={playerNames}/>
                </>
            }
            
            
        </div>
    );
};

export default GTNComponent;
